'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "list", "children"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
/**
 * @deprecated
 * This component will be archived soon.
 * Please use the Tabs component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navbar--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBar) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12653&t=X3Pv9ZLvoMIaXVBJ-1)
 **/
export var NavBar = function NavBar(_ref) {
  var as = _ref.as,
    list = _ref.list,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'section';
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.NavBar
  }), list, /*#__PURE__*/React.createElement("div", {
    className: ecx(['nav-bar'])
  }, children));
};